<ui-base-header
  [title]="
    ('@trust-center-tab' | isFeatureEnabled) && (hasTrustCenterUrl$ | async) === false
      ? '' : (buildTranslationKey('header.title') | translate)" [bgColor]="'primary'">
  <ng-container title>
    @if ('@trust-center-tab' | isFeatureEnabled) {
      @if ((hasTrustCenterUrl$ | async) === false) {
        <div class="flex flex-row items-center gap-2">
        {{ buildTranslationKey('header.title') | translate }}
        <svg-icon
          class="w-4 mt-0.5"
          [src]="'info-dark'"
          [ngbTooltip]="freemiumTitleTooltip"
          [placement]="'bottom'"
          [keepOnHover]="true"
            [tooltipClass]="'default-tooltip w-50'"
          ></svg-icon>
        </div>
      }
    }
  </ng-container>
  <ng-container place="left">
    <div class="flex gap-3 px-7.5">
      @for (tab of tabs; track $index) {
        @if (tab.featureFlag ? (tab.featureFlag | isFeatureEnabled) : true) {
          <app-tab-option
            place="left"
            [attr.data-test-id]="tab.tabId"
            [size]="'medium'"
            [routerLink]="tab.routerLink"
            [count]="tab.count"
            [hideCounterOnZero]="tab.hideCounterOnZero"
            [notificationDot]="tab.notificationDot"
          >
            {{ tab.translationKey | translate }}
          </app-tab-option>
        }
      }
    </div>
  </ng-container>

  <app-icon-button
    class="flex flex-shrink-0"
    tooltipClass="default-tooltip"
    [iconSize]="'large'"
    [type]="'secondary'"
    [svgIconPath]="'bulb'"
    [ngbTooltip]="buildTranslationKey('header.helpBtn') | translate"
    [placement]="'bottom'"
    (click)="openTrustGuidance()"
  ></app-icon-button>
</ui-base-header>

<ng-template #freemiumTitleTooltip>
  <div>
    <span>{{ buildTranslationKey('header.freemiumTooltipHeader') | translate }}</span>
    <span class="cursor-pointer underline"
          (click)="contactUs()">{{ buildTranslationKey('header.contactUs') | translate }}</span>
    <span>{{ buildTranslationKey('header.freemiumTooltipDescription') | translate }}</span>
  </div>
</ng-template>
